import StorefrontIcon from '@mui/icons-material/StorefrontRounded';
import RestaurantIcon from '@mui/icons-material/RestaurantRounded';
import LocalCafeIcon from '@mui/icons-material/LocalCafeRounded';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBagRounded';
import CheckroomIcon from '@mui/icons-material/CheckroomRounded';
import SpaIcon from '@mui/icons-material/SpaRounded';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenterRounded';
import MedicalIcon from '@mui/icons-material/MedicalServicesRounded';
import HomeIcon from '@mui/icons-material/HomeWorkRounded';
import CarIcon from '@mui/icons-material/DirectionsCarRounded';
import FlightIcon from '@mui/icons-material/FlightRounded';
import SchoolIcon from '@mui/icons-material/SchoolRounded';
import ComputerIcon from '@mui/icons-material/ComputerRounded';
import CameraIcon from '@mui/icons-material/PhotoCameraRounded';
import PetsIcon from '@mui/icons-material/PetsRounded';
import CelebrationIcon from '@mui/icons-material/CelebrationRounded';
import BuildIcon from '@mui/icons-material/HandymanRounded';
import CampaignIcon from '@mui/icons-material/CampaignRounded';

// Selectable business icons (separate from brand color). Keyed so we can store
// the choice and re-render it anywhere a business avatar appears.
export const BUSINESS_ICONS = [
  { key: 'storefront', Icon: StorefrontIcon },
  { key: 'restaurant', Icon: RestaurantIcon },
  { key: 'cafe', Icon: LocalCafeIcon },
  { key: 'shopping', Icon: ShoppingBagIcon },
  { key: 'fashion', Icon: CheckroomIcon },
  { key: 'spa', Icon: SpaIcon },
  { key: 'fitness', Icon: FitnessCenterIcon },
  { key: 'medical', Icon: MedicalIcon },
  { key: 'home', Icon: HomeIcon },
  { key: 'auto', Icon: CarIcon },
  { key: 'travel', Icon: FlightIcon },
  { key: 'education', Icon: SchoolIcon },
  { key: 'tech', Icon: ComputerIcon },
  { key: 'photo', Icon: CameraIcon },
  { key: 'pets', Icon: PetsIcon },
  { key: 'events', Icon: CelebrationIcon },
  { key: 'services', Icon: BuildIcon },
  { key: 'marketing', Icon: CampaignIcon },
];

const MAP = Object.fromEntries(BUSINESS_ICONS.map((b) => [b.key, b.Icon]));

export function getBusinessIcon(key) {
  return MAP[key] || null;
}
